// extracted by mini-css-extract-plugin
export default {"main":"TipoAsistenciaSelector_main__ZJS6h"};